/**
 * Переключение режима Seedance 2 («Кадры | Референсы») — ОДНА логика на все
 * места, где этот переключатель живёт (пилюли десктопа, шторка телефона).
 *
 * Смена режима не сводится к записи настройки: у режимов разные входы, и
 * оставленные от прошлого режима загрузки уехали бы в генерацию молча. «Кадры»
 * берут первый и последний кадр, «Референсы» — фото/видео/аудио-референсы,
 * поэтому при переключении чужие загрузки снимаются.
 */
import type { GenerateSettings } from '../hooks/useGenerateSettings'

export type SeedanceMode = 'frames' | 'references' | 'video'

/** То, что нужно переключателю от контекста генерации. */
export interface SeedanceSwitchApi {
	settings: Pick<GenerateSettings, 'seedanceMode'>
	updateSetting: (key: 'seedanceMode', value: SeedanceMode) => void
	setUploadedImage: (v: null) => void
	setEndImage: (v: null) => void
	setReferenceImages: (updater: () => never[]) => void
	setReferenceVideos: (updater: () => never[]) => void
	setReferenceVideo: (v: null) => void
}

export function switchSeedanceMode(api: SeedanceSwitchApi, mode: SeedanceMode): void {
	if (api.settings.seedanceMode === mode) return
	if (mode === 'frames') {
		api.setReferenceImages(() => [])
		api.setReferenceVideos(() => [])
		api.setReferenceVideo(null)
	} else if (mode === 'references') {
		api.setUploadedImage(null)
		api.setEndImage(null)
	}
	api.updateSetting('seedanceMode', mode)
}
